import { Switch } from 'antd-mobile';

import { appMethod as app } from '@utils/app';
import util from '@utils/util';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './PreviewPresellOrder.less';

export default class PreviewPresellOrder extends OfficialPage {
  state = {
    selectmodel: '',
    storeConfig: '',
    limit_buy: '',
    presell_status: '',
    description: '',
    goodsPrice: '',
    selectAddress: '',
    selectDelivery: '',
    pickUpType: '',
    presell_price: '',
    total_bargain: '',
    total_final_payment: '',
    final_payment_start_time: '',
    orderRemark: '',
    is_self_delivery: 0,
    totalPrice: 0,
    useBalance: true,
    cashOnDelivery: false,
    agreePayment: false,
    noAdditionalInfo: true,
    expressAddressNull: false,
    nums: 0,
    express_fee: 0,
    formid: [],
    cart_id_arr: [],
    goodsInfo: {},
    selectDiscountInfo: {},
    additional_info: {},
    shop: {
      id: '0'
    },
    exchangeCouponData: {
      dialogHidden: true,
      goodsInfo: {},
      selectModelInfo: {},
      hasSelectGoods: false,
      voucher_coupon_goods_info: {}
    },
    storeStyle: {}
  }

  constructor(props) {
    super(props);
    document.title = '确认订单';
    // WEBAPP: 处理后一个页面回来的回调
    if (app.getCurrentPage().callbackData) {
      this.currentPage = app.getCurrentPage();
    }
  }

  // WEBAPP: 处理后一个页面回来的回调
  handleCurrentPage() {
    if (!this.currentPage) {
      return;
    }
    const { callbackData } = this.currentPage;
    if (callbackData) {
      this.setData(callbackData);
      this.currentPage.clearCallbackData();
      if (this.currentPage.additional_info) {
        this.additional_info = this.currentPage.additional_info;
        delete this.currentPage.additional_info;
      }
      if (this.currentPage.hasRequiredSuppInfo) {
        this.hasRequiredSuppInfo = this.currentPage.hasRequiredSuppInfo;
        delete this.currentPage.hasRequiredSuppInfo;
      }
    }
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    var that = this,
      param = JSON.parse(decodeURIComponent(options.param)),
      pickUpType = param.type || 1,
      addressId = param.address_id
    that.setData({
      goods_id: param.goods_id || '',
      activity_id: param.activity_id || '',
      model_id: param.model_id || '',
      nums: param.nums || '',
      franchiseeId: param.sub_shop_app_id || '',
      address_id: param.address_id || '',
      pickUpType: pickUpType,
      models_text: param.models_text,
      models_stock: param.models_stock,
      final_payment_start_time: param.final_payment_start_time,
      bargain_order_id: param.bargain_order_id || '',
      presell_status: param.presell_status,
      limit_buy: param.limit_buy,
      sameJourneyTimeType: pickUpType == 2 ? 1 : '',
      selectSameJourneyId: pickUpType == 2 ? addressId : '',
      selectAddressId: pickUpType == 1 ? addressId : ''
    })
    this.loadInit()
    // WEBAPP特殊处理(这里是有问题的，待解决)
    setTimeout(() => {
      this.handleCurrentPage()
    }, 1000)
  }

  loadInit = () => {
    var that = this
    if (app.isLogin()) {
      this.getCalculationInfo()
    } else {
      app.goLogin({
        success: function () {
          that.getCalculationInfo()
        }
      })
    }
  }

  componentDidShow() {
    if (this.isFromSelectAddress) {
      this.getCalculationInfo()
      this.isFromSelectAddress = false
    }
  }

  getCalculationInfo = () => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppPreSell/Calculate',
      method: 'POST',
      data: {
        sub_shop_app_id: that.franchisee_id,
        selected_benefit: that.data.selectDiscountInfo,
        is_balance: that.data.useBalance ? 1 : 0,
        address_id:
          that.data.pickUpType == 1
            ? that.data.selectAddressId
            : that.data.selectSameJourneyId,
        pick_up_type: that.data.pickUpType,
        bargain_order_id: that.data.bargain_order_id || '',
        presell_shopping_cart: [
          {
            goods_id: that.data.goods_id,
            model_id: that.data.model_id,
            num: that.data.nums
          }
        ]
      },
      success: res => {
        let info = res.data
        let benefits = info.can_use_benefit
        let goods_info = info.goods_info
        let additional_info_goods = []
        let selectDiscountInfo = info.selected_benefit_info
        let suppInfoArr = []
        let additional_goodsid_arr = [] // 不在配送范围内直接弹窗
        let goodsBenefitsData = []
        let final_payment_name =
          goods_info[0].server_time > info.final_payment_start_time * 1
            ? util.formatTimeYMD(
              new Date(info.final_payment_end_time * 1000),
              'M月DD日 hh:mm'
            ) + ' 结束支付尾款'
            : util.formatTimeYMD(
              new Date(info.final_payment_start_time * 1000),
              'M月DD日 hh:mm'
            ) + ' 开始支付尾款'
        benefits.coupon_benefit && benefits.coupon_benefit.length
          ? goodsBenefitsData.push({
            label: 'coupon',
            value: benefits.coupon_benefit
          })
          : ''
        benefits.all_vip_benefit && benefits.all_vip_benefit.length
          ? goodsBenefitsData.push({
            label: 'vip',
            value: benefits.all_vip_benefit
          })
          : ''
        Array.isArray(benefits.integral_benefit)
          ? ''
          : benefits.integral_benefit &&
          goodsBenefitsData.push({
            label: 'integral',
            value: [benefits.integral_benefit]
          })
        if (
          selectDiscountInfo.discount_type == 'coupon' &&
          selectDiscountInfo.type == 3 &&
          that.data.exchangeCouponData.hasSelectGoods == false
        ) {
          that.exchangeCouponInit(parseInt(selectDiscountInfo.value))
        }
        for (var i = 0; i <= goods_info.length - 1; i++) {
          if (
            goods_info[i].delivery_id &&
            goods_info[i].delivery_id != 0 &&
            additional_goodsid_arr.indexOf(goods_info[i].id) == -1
          ) {
            suppInfoArr.push(goods_info[i].delivery_id)
            additional_goodsid_arr.push(goods_info[i].id)
            additional_info_goods.push(goods_info[i])
          }
        }
        if (suppInfoArr.length && !that.data.deliverydWrite) {
          that.getSuppInfo(suppInfoArr)
        }
        that.setData({
          goodsInfo: info.goods_info[0],
          total_price: info.price,
          presell_price: info.goods_info[0].price || '',
          total_bargain: info.total_bargain || '',
          total_final_payment: info.total_final_payment || '',
          expressAddressNull: info.address
            ? false
            : that.data.expressAddressNull,
          selectAddress: that.data.pickUpType == 1 && info.address,
          selectSameJourney: that.data.pickUpType == 2 && info.address,
          discountList: goodsBenefitsData,
          selectDiscountInfo: selectDiscountInfo,
          express_fee: info.express_fee,
          discount_cut_price: info.discount_cut_price,
          balance: info.balance,
          deduction: info.use_balance,
          original_price: info.original_price,
          totalPayment: info.price,
          canCashDelivery: info.is_pay_on_delivery || '', //快递货到付款
          cashOnDelivery: info.price > 0 ? that.data.cashOnDelivery : false,
          selfPayOnDelivery: info.self_pay_on_delivery || '', //自提货到付款
          additional_goodsid_arr: additional_goodsid_arr,
          final_payment_name: final_payment_name,
          sameJourneyImmediatlyTime:
            info.intra_city_status_data &&
            info.intra_city_status_data.deliver_time
        })
        app.setPreviewGoodsInfo(additional_info_goods)
      },
      successShowModalConfirm: res => {
        app.turnBack()
        return false
      }
    })
  }
  exchangeCouponInit = id => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/getGoods',
      data: {
        data_id: id
      },
      success: function (res) {
        var goods = res.data[0].form_data
        var goodsModel = []
        var selectModelInfo = {
          models: [],
          price: 0,
          modelId: '',
          models_text: '',
          imgurl: ''
        }
        if (goods.model_items.length) {
          selectModelInfo['price'] = Number(goods.model_items[0].price)
          selectModelInfo['imgurl'] = goods.model_items[0].img_url
          selectModelInfo['modelId'] = goods.model_items[0].id
        } else {
          selectModelInfo['price'] = Number(goods.price)
          selectModelInfo['imgurl'] = goods.cover
        }
        for (var key in goods.model) {
          if (key) {
            goodsModel.push(goods.model[key]) // 转成数组
            selectModelInfo['models'].push(goods.model[key].subModelId[0])
            selectModelInfo['models_text'] +=
              '“' + goods.model[key].subModelName[0] + '” '
          }
        }
        goods.model = goodsModel // 将原来的结构转换成数组
        that.setData({
          'exchangeCouponData.dialogHidden': false, // 显示模态框
          'exchangeCouponData.goodsInfo': goods,
          'exchangeCouponData.selectModelInfo': selectModelInfo
        })
      },
      successStatusAbnormal: function () {
        app.showModal({
          content: '兑换的商品已下架'
        })
      }
    })
  }
  clickMinusButton = e => {
    var goods = this.data.goodsInfo,
      num = +this.data.nums
    if (+num <= 0) return
    this.changeGoodsNum('minus')
  }
  clickPlusButton = e => {
    var goods = this.data.goodsInfo,
      num = +this.data.nums
    this.changeGoodsNum('plus')
  }
  inputGoodsCount = e => {
    var value = +e.target.value,
      limit_buy = this.data.limit_buy,
      newdata = {}
    if (limit_buy !== '' && limit_buy != 0 && value > limit_buy) {
      app.showModal({
        content:
          '已超过该商品的限购件数（每人限购' + this.data.limit_buy + '件）'
      })
      newdata['nums'] = limit_buy
      this.setData(newdata)
      return
    }
    clearTimeout(this.inputTimer)
    if (isNaN(value) || value <= 0) {
    } else {
      this.inputTimer = setTimeout(() => {
        this.changeGoodsNum(value)
      }, 500)
    }
  }
  verifyName = e => {
    var value = +e.target.value
    if (isNaN(value) || value <= 0) {
      app.showToast({
        title: '最少购买一件哦！',
        icon: 'none'
      })
      this.setData({
        nums: 1
      })
      this.inputTimer = setTimeout(() => {
        this.changeGoodsNum(1)
      }, 500)
      return
    }
  }
  changeGoodsNum = type => {
    var that = this,
      stock = +that.data.models_stock,
      limit_buy = +that.data.limit_buy,
      currentNum = +this.data.nums,
      targetNum =
        type == 'plus'
          ? currentNum + 1
          : type == 'minus'
            ? currentNum - 1
            : Number(type),
      newdata = {}
    if (this.data.presell_status == 3) {
      app.showModal({
        content: '不支持修改数量',
        confirm: function () {
          that.setData({
            nums: currentNum
          })
        }
      })
      return
    }
    if (type == 'plus' && limit_buy && +targetNum > limit_buy) {
      app.showModal({
        content: '已超过该商品的限购件数（每人限购' + limit_buy + '件）'
      })
      newdata['nums'] = limit_buy
      this.setData(newdata)
      return
    }
    if (+targetNum == 0 && type == 'minus') {
      newdata['nums'] = 1
      this.setData(newdata)
      return
    }
    if (+targetNum > stock) {
      app.showModal({
        content: '购买数量不能大于库存'
      })
      newdata['nums'] = stock
      this.setData(newdata)
      return
    }
    newdata['nums'] = +targetNum
    this.setData(newdata)
    this.getCalculationInfo()
  }
  payOrder = orderId => {
    var that = this
    function paySuccess() {
      var pagePath =
        '/presell/pages/presellPaySuccess/presellPaySuccess?detail=' +
        (that.data.bargain_order_id || orderId) +
        '&presell_status=' +
        that.data.presell_status +
        (that.franchisee_id ? '&franchisee=' + that.franchisee_id : '')
      if (!that.franchisee_id) {
        app.sendRequest({
          url: '/index.php?r=AppMarketing/CheckAppCollectmeStatus',
          data: {
            order_id: orderId,
            sub_app_id: that.franchisee_id
          },
          success: function (res) {
            if (res.valid == 0) {
              pagePath += '&collectBenefit=1'
            }
            that.saveUserFormId(pagePath, 1)
          }
        })
      } else {
        that.saveUserFormId(pagePath, 1)
      }
    }
    function payFail() {
      var pagePath =
        '/presell/pages/presellOrderDetail/presellOrderDetail?detail=' +
        (that.data.bargain_order_id || orderId) +
        (that.franchisee_id ? '&franchisee=' + that.franchisee_id : '')
      that.saveUserFormId(pagePath, 1)
    }
    if (this.data.totalPayment == 0) {
      app.sendRequest({
        url: '/index.php?r=AppShop/paygoods',
        data: {
          order_id: orderId,
          total_price: 0
        },
        success: function (res) {
          paySuccess()
        },
        fail: function () {
          payFail()
        },
        successStatusAbnormal: function () {
          payFail()
        }
      })
      return
    }
    // app.sendRequest({
    //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
    //   data: {
    //     order_id: orderId
    //   },
    //   success: function (res) {
    //     var param = res.data
    //     param.orderId = orderId
    //     param.success = paySuccess
    //     param.goodsType = 0
    //     param.fail = payFail
    //     that.wxPay(param)
    //   },
    //   fail: function () {
    //     payFail()
    //   },
    //   successStatusAbnormal: function () {
    //     payFail()
    //   }
    // })
    app.goPay({
      orderId: orderId,
      franchisee: that.franchisee_id,
      successUrl: '/presellPaySuccess?detail=' + (that.data.bargain_order_id || orderId) + '&presell_status=' + that.data.presell_status + (that.franchisee_id ? '&franchisee=' + that.franchisee_id : ''),
      failUrl: '/presellOrderDetail?detail=' + (that.data.bargain_order_id || orderId) + (that.franchisee_id ? '&franchisee=' + that.franchisee_id : ''),
      cancel: payFail
    })
  }
  wxPay = param => {
    var that = this
    app.requestPayment({
      timeStamp: param.timeStamp,
      nonceStr: param.nonceStr,
      package: param.package,
      signType: param.signType,
      paySign: param.paySign,
      success: function (res) {
        app.wxPaySuccess(param)
        param.success()
      },
      fail: function (res) {
        if (res.errMsg === 'requestPayment:fail cancel') {
          app.showModal({
            content: '支付已取消',
            complete: param.fail
          })
          return
        }
        app.showModal({
          content: '支付失败',
          complete: param.fail
        })
        app.wxPayFail(param, res.errMsg)
      }
    })
  }
  confirmPayment = e => {
    var that = this,
      formid = that.data.formid,
      selected_benefit = this.data.selectDiscountInfo,
      tostoreOrderType = this.data.tostoreOrderType
    formid.push(e.target.formId)
    that.setData({
      formid: formid
    })
    if (this.data.pickUpType == 1 && !this.data.selectAddress) {
      this.setData({
        expressAddressNull: true
      })
      return
    }
    if (!this.data.agreePayment && this.data.presell_status != 3) {
      app.showModal({
        content: '请先开启同意支付定金'
      })
      return
    }
    if (this.data.pickUpType == 2 && !this.data.selectSameJourney) {
      app.showModal({
        content: '请选择同城地址',
        confirmText: '去填写',
        confirm: function () {
          that.goSameJourneyAddress()
        }
      })
      return
    }
    if (
      this.data.pickUpType == 2 &&
      !this.data.sameJourneyDateTime &&
      this.data.sameJourneyTimeType != 1
    ) {
      app.showModal({
        content: '请选择取货时间'
      })
      return
    }
    if (this.data.pickUpType == 3 && !this.data.selectDelivery) {
      app.showModal({
        content: '请选择上门自提地址',
        confirmText: '去填写',
        confirm: function () {
          that.toDeliveryList()
        }
      })
      return
    }
    if (
      this.data.pickUpType == 3 &&
      this.data.selfAppointmentSwitch &&
      !tostoreOrderType
    ) {
      app.showModal({
        content: '请选择取货时间'
      })
      return
    }
    let year = new Date().getFullYear()
    let tostoreDateTime =
      year +
      '-' +
      this.data.tostoreDateTime +
      ' ' +
      (this.data.tostoreHourTime || '')
    if (
      this.data.pickUpType == 3 &&
      this.data.selfDeliveryPhone == 1 &&
      !util.isPhoneNumber(this.data.phone)
    ) {
      app.showModal({
        content: '请输入正确的手机号'
      })
      return
    }
    if (
      this.data.hasRequiredSuppInfo &&
      !this.data.deliverydWrite &&
      !this.data.aloneDeliveryShow &&
      this.data.presell_status == 3
    ) {
      app.showModal({
        content: '商品补充信息未填写，无法进行支付',
        confirmText: '去填写',
        confirm: function () {
          that.goToAdditionalInfo()
        }
      })
      return
    }
    if (this.data.aloneDeliveryShow && this.data.presell_status == 3) {
      let a = this.data.additional_info
      let id = this.data.additional_goodsid_arr[0]
      if (a[id][0].is_required == 0 && a[id][0].value == '') {
        app.showModal({
          content: '请填写' + a[id][0].title,
          confirmText: '确认'
        })
        return
      }
    }
    if (this.requesting) {
      return
    }
    this.requesting = true
    app.sendRequest({
      url: '/index.php?r=AppPreSell/AddOrder',
      method: 'post',
      data: {
        sub_shop_app_id: that.franchisee_id,
        selected_benefit: selected_benefit,
        is_balance: that.data.useBalance ? 1 : 0,
        address_id:
          that.data.pickUpType == 1
            ? that.data.selectAddress.id
            : that.data.selectSameJourney.id,
        pick_up_type: that.data.pickUpType,
        self_delivery_app_store_id:
          that.data.pickUpType == 3 ? that.data.selectDelivery.id : '',
        bargain_order_id: that.data.bargain_order_id || '',
        form_id: that.data.form_id || [],
        remark: this.data.orderRemark,
        presell_shopping_cart: [
          {
            goods_id: that.data.goods_id,
            model_id: that.data.model_id,
            num: that.data.nums
          }
        ],
        additional_info: this.data.additional_info
      },
      success: function (res) {
        if (that.data.cashOnDelivery) {
          let pagePath =
            '/presell/pages/presellPaySuccess/presellPaySuccess?detail=' +
            (that.data.bargain_order_id || res.data) +
            '&presell_status=' +
            that.data.presell_status +
            (that.franchisee_id ? '&franchisee=' + that.franchisee_id : '')
          that.saveUserFormId(pagePath, 1)
        } else {
          that.setData({
            totalPayment: res.total_price
          })
          that.payOrder(res.data)
        }
      },
      complete: function () {
        app.hideLoading()
      },
      successShowModalConfirm: res => {
        app.turnBack()
        return false
      },
      fail: function () {
        that.requesting = false
      },
      successStatusAbnormal: function () {
        that.requesting = false
      }
    })
  }
  useBalanceChange = checked => {
    this.setData({
      useBalance: checked
    })
    this.getCalculationInfo()
  }
  agreePayment = e => {
    var agreePayment = !this.data.agreePayment
    this.setData({
      agreePayment: agreePayment
    })
  }
  goToMyAddress = () => {
    var addressId = this.data.selectAddress && this.data.selectAddress.id
    var pagePath = '/eCommerce/pages/myAddress/myAddress?id=' + addressId
    this.isFromSelectAddress = true
    this.saveUserFormId(pagePath, 0)
  }
  formSubmit_collect = e => {
    let formid = this.data.formid
    formid.push(e.target.formId)
  }
  saveUserFormId = (path, isRedirect) => {
    app.showLoading({
      title: '加载中'
    })
    var that = this
    app.sendRequest({
      url: '/index.php?r=api/AppMsgTpl/saveUserFormId',
      method: 'post',
      data: {
        sub_shop_app_id: that.data.franchiseeId || '',
        form_id: that.data.formid || []
      },
      complete: function () {
        app.hideLoading()
        app.turnToPage(path, isRedirect)
        that.setData({
          formid: []
        })
      }
    })
  }
  remarkInput = e => {
    var value = e.target.value
    this.setData({
      orderRemark: value
    })
  }
  manuallyAddAddress = () => {
    this.isFromSelectAddress = true
    app.turnToPage('/eCommerce/pages/addAddress/addAddress')
  }
  importWeChatAddress = () => {
    let _this = this
    app.chooseAddress({
      success: function (res) {
        app.sendRequest({
          method: 'post',
          url: '/index.php?r=AppShop/AddWxAddress',
          data: {
            detailInfo: res.detailInfo || '',
            cityName: res.cityName || '',
            provinceName: res.provinceName || '',
            UserName: res.userName || '',
            telNumber: res.telNumber || '',
            district: res.district || '',
            countyName: res.countyName || ''
          },
          success: function () {
            _this.getCalculationInfo()
          }
        })
      }
    })
  }
  showMemberDiscount = () => {
    this.selectComponent('#component-memberDiscount').showDialog(
      this.data.selectDiscountInfo
    )
  }
  afterSelectedBenefit = event => {
    this.setData({
      selectDiscountInfo: event.detail.selectedDiscount,
      'exchangeCouponData.hasSelectGoods': false,
      'exchangeCouponData.voucher_coupon_goods_info': {}
    })
    this.getCalculationInfo()
  }
  getSuppInfo = suppInfoArr => {
    var _this = this
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=pc/AppShop/GetDelivery',
      method: 'post',
      data: {
        delivery_ids: suppInfoArr
      },
      success: function (res) {
        for (let i = 0; i < res.data.length; i++) {
          let suppInfo = res.data[i].delivery_info
          for (let j = 0; j < suppInfo.length; j++) {
            if (suppInfo[j].is_required == 0 && suppInfo[j].is_hidden == 1) {
              _this.setData({
                hasRequiredSuppInfo: true
              })
            }
            if (suppInfo[j].is_hidden == 1) {
              _this.setData({
                noAdditionalInfo: false
              })
            }
          }
        }
        if (
          res.data.length == 1 &&
          _this.data.additional_goodsid_arr.length == 1
        ) {
          let deliveryIndex = 0
          let showIndex = 0
          for (let i = 0; i < res.data[0].delivery_info.length; i++) {
            if (res.data[0].delivery_info[i].is_hidden == 1) {
              deliveryIndex++
              showIndex = i
            }
          }
          if (deliveryIndex == 1) {
            let data = {}
            data[_this.data.additional_goodsid_arr[0]] = []
            data[_this.data.additional_goodsid_arr[0]].push({
              title: res.data[0].delivery_info[showIndex].name,
              type: res.data[0].delivery_info[showIndex].type,
              is_required: res.data[0].delivery_info[showIndex].is_required,
              value: ''
            })
            _this.setData({
              additional_info: data,
              aloneDeliveryShow: true
            })
          }
        }
      }
    })
  }
  goToAdditionalInfo = () => {
    app.setGoodsAdditionalInfo(this.data.additional_info)
    app.turnToPage('/eCommerce/pages/goodsAdditionalInfo/goodsAdditionalInfo')
  }
  inputFormControl = e => {
    let a = this.data.additional_info
    let b = this.data.additional_goodsid_arr[0]
    a[b][0].value = e.target.value
    this.setData({
      additional_info: a
    })
  }
  addDeliveryImg = () => {
    let _this = this
    let a = this.data.additional_info
    let b = this.data.additional_goodsid_arr[0]
    let images = a[b][0].value || []
    app.chooseImage(image => {
      a[b][0].value = images.concat(image)
      _this.setData({
        additional_info: a
      })
    }, 9 - a[b][0].value.length)
  }
  deleteImage = e => {
    let _this = this
    let a = this.data.additional_info
    let b = this.data.additional_goodsid_arr[0]
    let index = e.currentTarget.dataset.imageIndex
    let images = a[b][0].value
    images.splice(index, 1)
    a[b][0].value = images
    _this.setData({
      additional_info: a
    })
  }

  render() {
    const {
      showGetUserInfo,
      discountList,
      presell_status,
      selectAddress,
      storeStyle,
      goodsInfo,
      models_text,
      presell_price,
      is_group,
      goodsIndex,
      goods,
      nums,
      exchangeCouponData,
      total_bargain,
      total_final_payment,
      final_payment_name,
      selectDiscountInfo,
      selectDiscountIndex,
      discount_cut_price,
      express_fee,
      useBalance,
      deduction,
      balance,
      agreePayment,
      orderRemark,
      noAdditionalInfo,
      aloneDeliveryShow,
      hasRequiredSuppInfo,
      deliverydWrite,
      additional_info,
      additional_goodsid_arr,
      total_price,
      expressAddressNull
    } = this.state
    return (
      <div className="official-page preview-presell-order">
        <TopNav title="确认订单"/>
        <React.Fragment>
          <div className="preview-goods-wrap">
            <div className="preview-section">
              {selectAddress.id ? (
                <React.Fragment>
                  <div
                    className="address-box isRelative"
                    onClick={presell_status == 3 ? null : this.goToMyAddress}
                    data-address-id={selectAddress.id}
                  >
                    <span className="ico-moon icon-goods-location"></span>
                    <div className="address-detail">
                      <div className="buyer-name-box">
                        <span
                          className="store-config-label"
                          style={convertLineStyleData('background:' + storeStyle.theme)}
                        >
                          快递
                            </span>
                        <span className="buyer-name">
                          {selectAddress.address_info.name}
                        </span>
                        <span>{selectAddress.address_info.contact}</span>
                      </div>
                      <div className="buyer-address">
                        {selectAddress.address_info.province.text +
                          selectAddress.address_info.city.text +
                          selectAddress.address_info.district.text +
                          selectAddress.address_info.detailAddress}
                      </div>
                    </div>
                    {presell_status != 3 && (
                      <div className="ico-moon icon-rightarrow"></div>
                    )}
                  </div>
                </React.Fragment>
              ) : (
                  <React.Fragment>
                    <div
                      className="address-null-box isRelative"
                      onClick={presell_status == 3 ? null : this.goToMyAddress}
                    >
                      {presell_status != 3 && (
                        <div className="pull-right ico-moon icon-rightarrow"></div>
                      )}
                      <div>
                        <span className="ico-moon icon-goods-location"></span>
                        <span className="add-new-address">新增地址</span>
                      </div>
                    </div>
                  </React.Fragment>
                )}
            </div>
            <div className="address-bg">
              <img src="http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/goods-address-bg.png" />
            </div>
            <div className="preview-goods-order-list">
              <div className="preview-goods-order-item">
                <img
                  className="preview-goods-cover"
                  src={goodsInfo.cover}
                  mode="aspectFill"
                />
                <div className="preview-goods-content">
                  <div className="preview-goods-title">
                    <span className="exchange-tip">预售</span>
                    {goodsInfo.title}
                  </div>
                  {models_text && (
                    <div className="preview-goods-model">{models_text}</div>
                  )}
                  <div className="goods-price-box">
                    {goodsInfo.integral != '2' ? (
                      <React.Fragment>
                        <span
                          className="preview-goods-price"
                          style={convertLineStyleData('color:' + storeStyle.theme)}
                        >
                          {'¥ ' + presell_price}
                        </span>
                      </React.Fragment>
                    ) : (
                        <React.Fragment>
                          {goodsInfo.price != '0.00' && (
                            <span
                              className="preview-goods-price"
                              style={convertLineStyleData(
                                !is_group ? 'color:' + storeStyle.theme : ''
                              )}
                            >
                              {'¥ ' + presell_price}
                            </span>
                          )}
                          {goodsInfo.price != '0.00' &&
                            goodsInfo.use_integral != 0 && (
                              <span
                                className="preview-goods-price"
                                style={convertLineStyleData(
                                  !is_group ? 'color:' + storeStyle.theme : ''
                                )}
                              >
                                +
                                </span>
                            )}
                          {goodsInfo.use_integral != 0 && (
                            <span
                              className="preview-goods-price"
                              style={convertLineStyleData(
                                !is_group ? 'color:' + storeStyle.theme : ''
                              )}
                            >
                              {goodsInfo.max_can_use_integral + '积分'}
                            </span>
                          )}
                        </React.Fragment>
                      )}
                    {presell_status == 3 ? (
                      <div className="good-number-box  pull-right">
                        {'x ' + goodsInfo.num}
                      </div>
                    ) : (
                        <div className="good-number-box pull-right">
                          <div
                            className="goods-minus isRelative"
                            data-index={goodsIndex}
                            onClick={this.clickMinusButton}
                          >
                            -
                          </div>
                          <input
                            className="goods-count"
                            data-index={goodsIndex}
                            type="number"
                            value={nums}
                            onChange={this.inputGoodsCount}
                            onBlur={this.verifyName}
                          />
                          <div
                            className="goods-plus isRelative"
                            style={convertLineStyleData('color:' + storeStyle.theme)}
                            data-index={goodsIndex}
                            onClick={this.clickPlusButton}
                          >
                            +
                          </div>
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
            {exchangeCouponData.hasSelectGoods && (
              <div className="preview-goods-order-list">
                <div className="preview-goods-order-item">
                  <img
                    className="preview-goods-cover"
                    src={exchangeCouponData.goodsInfo.cover}
                  />
                  <div className="preview-goods-content">
                    <div className="preview-goods-title">
                      <span className="exchange-tip">预售</span>
                      {exchangeCouponData.goodsInfo.title}
                    </div>
                    {exchangeCouponData.goodsInfo.model_value_str && (
                      <div className="preview-goods-model">
                        {exchangeCouponData.goodsInfo.model_value_str}
                      </div>
                    )}
                    <div className="goods-number-contain">
                      <div className="exchange-num pull-right">x1</div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="presell-price-item">
              <div className="presell-tips">
                <div
                  className={'role ' + (presell_status != 3 ? 'active' : '')}
                ></div>
                <div className="line"></div>
                <div
                  className={'role ' + (presell_status == 3 ? 'active' : '')}
                ></div>
              </div>
              <div className="presell-price">
                <div
                  className="presell-section"
                  style={convertLineStyleData('color: ' + (presell_status != 3 ? '#FF4D4F' : ''))}
                >
                  {'阶段1 ：定金 ¥ ' + total_bargain}
                </div>
                <div className="presell-section">
                  <div
                    style={convertLineStyleData('color: ' + (presell_status == 3 ? '#FF4D4F' : ''))}
                  >
                    {'阶段2 ：尾款 ¥ ' + total_final_payment}
                  </div>
                  <div>{final_payment_name}</div>
                </div>
              </div>
            </div>
            {discountList && !!discountList.length && (
              <div
                onClick={this.showMemberDiscount}
                className="isRelative showMemberDiscount"
              >
                <div className="balance-switch">
                  <span>优惠方式</span>
                  <div className="ico-moon icon-rightarrow pull-right"></div>
                  <span className="pull-right select-discount">
                    {selectDiscountInfo.name}
                  </span>
                </div>
                <div
                  hidden={selectDiscountIndex == 0}
                  className="balance-price"
                >
                  <span
                    className="pull-right"
                    style={convertLineStyleData('color:' + storeStyle.theme)}
                  >
                    {'- ¥ ' + discount_cut_price}
                  </span>
                </div>
              </div>
            )}
            <div className="preview-goods-express-fee">
              <span>运费</span>
              <span className="pull-right">
                {express_fee == '0' ? '包邮' : '¥' + express_fee}
              </span>
            </div>
            {balance != 0 && (
              <div className="payment-balance">
                <div className="balance-switch">
                  <span>使用储值金</span>
                  <Switch
                    style={convertLineStyleData("transform: scale(.8)")}
                    className="pull-right"
                    checked={useBalance}
                    onChange={this.useBalanceChange}
                  ></Switch>
                </div>
                <div hidden={!useBalance} className="balance-price">
                  <span className="pull-right">{'- ¥ ' + deduction}</span>
                </div>
              </div>
            )}
            {presell_status != 3 && (
              <div className="payment-deposit">
                <div>
                  <div>同意支付定金</div>
                  <div className="tips">预售商品，定金不退哦～</div>
                </div>
                <Switch
                  color={storeStyle.theme}
                  style={convertLineStyleData("transform: scale(.8)")}
                  className="pull-right"
                  checked={agreePayment}
                  onChange={this.agreePayment}
                ></Switch>
              </div>
            )}
            {presell_status == 3 && (
              <div className="preview-box">
                <div className="buyer-message single-box">
                  买家留言
                      <div className="pull-right">
                    <input
                      className="remark"
                      maxLength="30"
                      value={orderRemark}
                      onChange={this.remarkInput}
                      placeholder="买家留言"
                    />
                  </div>
                </div>
                {!noAdditionalInfo && !aloneDeliveryShow && (
                  <div
                    className="border-top1 single-box"
                    onClick={this.goToAdditionalInfo}
                  >
                    补充信息
                        <div className="ico-moon icon-rightarrow pull-right"></div>
                    <span
                      style={convertLineStyleData(
                        'color:' +
                        (hasRequiredSuppInfo && !deliverydWrite
                          ? storeStyle.theme
                          : '#666')
                      )}
                      className="additional-tip pull-right"
                    >
                      {deliverydWrite ? '已填写' : '未填写'}
                    </span>
                  </div>
                )}
              </div>
            )}
            {/*  单件商品展示补充信息  */}
            {aloneDeliveryShow && presell_status == 3 && (
              <React.Fragment>
                {additional_info[additional_goodsid_arr[0]].map(
                  (item, index) => {
                    return (
                      <div className="additional-list" key={index}>
                        {item.type == 'text' && (
                          <div className="additional-text">
                            <span
                              className={
                                'additional-name ' +
                                (item.is_required == 0 ? 'is-required' : '')
                              }
                            >
                              {item.title}
                            </span>
                            <div className="additional-info">
                              <input
                                type="text"
                                onChange={this.inputFormControl}
                                value={item.value}
                              />
                            </div>
                          </div>
                        )}
                        {item.type == 'mul-text' && (
                          <div className="additional-textarea">
                            <span
                              className={
                                'additional-name ' +
                                (item.is_required == 0 ? 'is-required' : '')
                              }
                            >
                              {item.title}
                            </span>
                            <div className="additional-info">
                              <textarea
                                maxLength="-1"
                                onInput={this.inputFormControl}
                                value={item.value}
                              ></textarea>
                            </div>
                          </div>
                        )}
                        {item.type == 'picture' && (
                          <div className="additional-picture">
                            <span
                              className={
                                'additional-name ' +
                                (item.is_required == 0 ? 'is-required' : '')
                              }
                            >
                              {item.title}
                            </span>
                            <div className="additional-info">
                              {item.value.map((imgSrc, imageIndex) => {
                                return (
                                  <div className="image-list" key={imageIndex}>
                                    <img src={imgSrc} />
                                    <label
                                      className="delete-image ico-moon icon-closes isRelative"
                                      onClick={this.deleteImage}
                                      data-image-index={imageIndex}
                                    >
                                      -
                                    </label>
                                  </div>
                                )
                              })}
                              {item.value.length < 9 && (
                                <div
                                  className="add-images isRelative"
                                  onClick={this.addDeliveryImg}
                                >
                                  <span className="ico-moon icon-goods-add-image"></span>
                                  <div>添加图片</div>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    )
                  }
                )}
              </React.Fragment>
            )}
            <div className="bottom-nav">
              <form>
                {presell_status == 3 ? (
                  <button
                    type="button"
                    onClick={this.confirmPayment}
                    style={convertLineStyleData('background:' + storeStyle.theme)}
                    className="paymentDeposit"
                  >
                    {'支付尾款 ¥ ' + total_price}
                  </button>
                ) : (
                    <button
                      type="button"
                      onClick={this.confirmPayment}
                      style={convertLineStyleData('background:' + storeStyle.theme)}
                      className="paymentDeposit"
                    >
                      {'支付定金 ¥ ' + total_price}
                    </button>
                  )}
              </form>
            </div>
            {expressAddressNull && (
              <div
                className="perfect-address-mask"
                onClick={this.hidePerfectAddress}
              >
                <div
                  className="perfect-address-box"
                  onClick={this.stopPropagation}
                >
                  <div className="perfect-address-title">提示</div>
                  <div className="perfect-address-tips">
                    请完善地址信息~
                      </div>
                  <div className="perfect-address-bottom">
                    <span onClick={this.manuallyAddAddress}>
                      手动新增地址
                        </span>
                    <span
                      onClick={this.importWeChatAddress}
                      className="import-weChat-address"
                    >
                      导入微信地址
                        </span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </React.Fragment>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/preview-presell-order/PreviewPresellOrder.jsx